import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.10156 19.9364H15.8952V16.782H11.7276V5.46881H4.10156V8.62321H8.17316V16.782H4.10156V19.9364ZM15.0952 19.1364H4.90156V17.582H8.97316V7.82321H4.90156V6.26881C6.11068 6.26881 9.71844 6.26881 10.9276 6.26881V17.582H15.0952V19.1364Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.82134 4.45576C11.0488 4.33436 11.9453 3.24092 11.8239 2.01356C11.7025 0.786197 10.6091 -0.110363 9.38166 0.0110766C8.15426 0.132517 7.25774 1.22592 7.37918 2.45328C7.50058 3.68068 8.59402 4.5772 9.82134 4.45576ZM9.74262 3.65968C8.9549 3.7376 8.25322 3.1622 8.17526 2.37452C8.09734 1.58684 8.6727 0.885117 9.46038 0.807197C10.2481 0.729277 10.9498 1.30464 11.0278 2.09232C11.1057 2.88004 10.5303 3.58172 9.74262 3.65968Z"
		})
	]
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
